import React from 'react';
import { Toast } from './Toast';
import { useToast } from './ToastContext';
import { ToasterProps } from './Toaster.types';
import './Toaster.scss';

export const Toaster: React.FC<ToasterProps> = ({ position = 'top-right' }) => {
    const { toasts, removeToast } = useToast();

    if (toasts.length === 0) {
        return null;
    }

    return (
        <div className={`toaster toaster-${position}`}>
            {toasts.map((toast) => (
                <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
            ))}
        </div>
    );
};
